import { getQueryKeys } from "../../helper";

const namespace = "flights";

export default {
  ...getQueryKeys(namespace),
};
